import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * 
 * @param {*} filterKey - If we need to get only 1 filter and listent to its change
 * @returns array of values for the filter key
 * if no filter key provided, will listed to all filter change and returns all filters
 * Usefull when you don't want to trigger effects on pagination change as it is also in the url
 */
export default function useUrlFilters(filterKey){
    const location = useLocation();
    let filterString = new URLSearchParams(location.search).get("filters");
    if(filterKey){
        filterString = JSON.stringify((JSON.parse(filterString)?.[filterKey] ?? []));
    }
    return useMemo(() => {
        if(filterKey){
            if(filterString.length === 0){
                return [];
            } else {
                return JSON.parse(filterString);
            }
        }
        return JSON.parse(filterString || "{}");
    }, [filterString, filterKey]);
}